import { Badge, Box, Flex, Button, Paper, Text, rem, Stack, Group, ThemeIcon, Divider } from "@mantine/core"; // replace 'your-ui-library' with the actual library you're using
import {
  IconCalendar,
  IconMapPin,
  IconCar,
  IconWheelchair,
  IconRepeat,
} from "@tabler/icons-react";
import { memo, useEffect, useState } from "react";
import { formattedDateTime, humenReadableTime } from "../../utils/datetime";
import { JobInfoProps } from "../CreateJob/type";

const style = { width: rem(16), height: rem(16) };

const LocationIcon = <IconMapPin style={style} />;

const CalendarIcon = <IconCalendar style={style} />;

const CarIcon = <IconCar style={style} />;

const WheelChairIcon = <IconWheelchair style={style} color="blue" />;

const isUser = localStorage.getItem("user") ? true : false;

const MyJobs = memo(
  ({
    job,
    driverId,
    ismyjob,
    id,
  }: {
    job: JobInfoProps;
    driverId?: string | null;
    ismyjob?: boolean;
    id?: string[];
  }) => {
    // replace 'your-driver-id' with the actual driver id
    const isMatch = id?.includes(job.id)

    const [todayJob, setTodayJob] = useState<JobInfoProps | null>()

    useEffect(() => {
      console.log('job.occurences', job.occurences);

      const match = job.occurences?.find((occurence: JobInfoProps) => occurence.pickup_at === new Date().toISOString().split('T')[0])
      if (!match) {
        setTodayJob(null)
        return
      }
      setTodayJob(match)
    }, [job])


    let badgeColor;
    switch (job.status) {
      case "assigned":
        badgeColor = "orange";
        break;
      case "uncovered":
        badgeColor = "gray";
        break;
      case "completed":
        badgeColor = "green";
        break;
      case "cancelled":
        badgeColor = "red";
        break;
      default:
        badgeColor = "gray";
    }

    const renderBadgeColor = (status: string): string => {
      switch (status) {
        case "scheduled":
          return "orange";
        case "in_progress":
          return "yellow";
        case "completed":
          return "green";
        case "cancelled":
          return "red";
        default:
          return "gray";
      }
    }

    return (
      <Paper
        shadow="sm"
        p="lg"
        radius="md"
        withBorder
        mt="md"
        key={job.id}
        onClick={() => (window.location.href = `/job?id=${job.id}`)}
        style={{ cursor: "pointer", position: "relative" }}
      >
        <Stack gap="sm">
          <Group justify="space-between">
            <Group gap="sm">
              <ThemeIcon variant="light" color="gray">
                <IconCalendar style={{ width: rem(16), height: rem(16) }} />
              </ThemeIcon>
              <Text size="sm" fw={500}>
                {formattedDateTime(todayJob ? todayJob.pickup_at : job.pickup_at)}
              </Text>
            </Group>
            <Badge color="dark" size="xl" variant="filled">
              {job.booking_id}
            </Badge>
          </Group>

          <Divider />

          <Stack gap="xs">
            <Group gap="xs">
              <ThemeIcon variant="light" color="gray" size="sm">
                <IconMapPin style={{ width: rem(14), height: rem(14) }} />
              </ThemeIcon>
              <Text size="sm" fw={500}>
                {job.pickupLoc}
              </Text>
              <Text size="xs" c="dimmed">
                (Pickup)
              </Text>
            </Group>
            <Group gap="xs">
              <ThemeIcon variant="light" color="gray" size="sm">
                <IconMapPin style={{ width: rem(14), height: rem(14) }} />
              </ThemeIcon>
              <Text size="sm" fw={500}>
                {job.dropLoc}
              </Text>
              <Text size="xs" c="dimmed">
                (Drop)
              </Text>
            </Group>
          </Stack>

          <Divider />

          <Group justify="space-between">
            <Group gap="xs" align="center">
              <ThemeIcon
                variant="light"
                color={job.services_required.includes("wheel") ? "blue" : "gray"}
              >
                {job.services_required.includes("wheel") ? (
                  <IconWheelchair style={{ width: rem(16), height: rem(16) }} />
                ) : (
                  <IconCar style={{ width: rem(16), height: rem(16) }} />
                )}
              </ThemeIcon>
              <Text size="sm" fw={500}>
                {job.services_required}
              </Text>
            </Group>
            {job.repeat_booking && (
              <Badge
                variant="filled"
                color="green"
                size="md"
                leftSection={<IconRepeat size={14} />}
              >
                Recurring
              </Badge>
            )}
          </Group>

          <Group justify="space-between" mt="xs">
            <Text size="sm" c="dimmed">
              Posted {humenReadableTime(job.posted_at)}
            </Text>
            <Text size="lg" fw={700}>
              {job.amount ? `$${(job.amount).toFixed(2)}` : ""}
            </Text>
          </Group>

          <Group justify="space-between" mt="xs">
            {job.repeat_booking && !todayJob && new Date(job.posted_at).toLocaleDateString().split('T')[0] !== new Date().toLocaleDateString().split('T')[0] ? (
              <Badge color={renderBadgeColor('other')} size="md" variant="light">
                {'Wait Next Trip'}
              </Badge>
            ) : todayJob ? (
              <Badge color={renderBadgeColor(todayJob.status)} size="md" variant="light">
                {todayJob.status}
              </Badge>
            ) : (
              <Badge color={badgeColor} size="md" variant="light">
                {job.status}
              </Badge>
            )}

            {isMatch && job.status === "pending" && job.posted_by === driverId &&
              <Badge color={"yellow"} size="md" variant="light">
                {'Driver Invited'}
              </Badge>
            }
          </Group>

        </Stack>
        <Box pos={"absolute"} top={45} right={10}>
          {job.posted_by !== driverId && job.assigned_to !== driverId ? (
            <Badge color="blue" size="md" variant="filled">
              Invited
            </Badge>
          ) : null}


          {job.assigned_to !== driverId &&
            job.posted_by === driverId &&
            job.public && (
              <Badge color="primary" size="md" variant="filled">
                Public
              </Badge>
            )}

          {job.posted_by === driverId && job.status === "cancelled" && (
            <Badge color="red" size="md" variant="filled">
              Cancelled
            </Badge>
          )}
        </Box>
      </Paper>
    );
  }
);

export default MyJobs;
